/**
 * OVERRIDE NavItems.jsx
 */

import NavItems from '../../../../components/Navigation/NavItems';

export default NavItems;